import mapboxgl from 'mapbox-gl'
import { MapLegend } from '~/models'
import { LotTypes } from '~/enums/lots'

// this function is the same that retrieveLegendsFromMap
// but I duplicated bcos I still need to know if we have to show
// the legend in an specific order like in retrieveLegendsForOpsMap
const retrieveLegendsMap = (
  map: mapboxgl.Map,
  legendLayers: Array<{
    status: string
    order: number
    label: string
    color?: string
  }>
): MapLegend[] => {
  if (!map) {
    return []
  }

  const style = map.getStyle()
  const layers: any = style.layers.filter(({ id }) =>
    legendLayers.some((layer) => layer.status === id)
  )

  const getMapLayer = (layerId: any): any =>
    legendLayers.find((legendLayer) => legendLayer.status === layerId) || {}

  const legends = layers.map((layer: any) => ({
    id: layer.id,
    key: layer.id,
    label: getMapLayer(layer.id).label,
    color:
      getMapLayer(layer.id).color || layer.paint['fill-color'] || '#000000',
    order: getMapLayer(layer.id).order,
    show: getMapLayer(layer.id).show,
  }))

  return legends.sort((entryA: any, entryB: any) => entryA.order - entryB.order)
}

const retrieveLegendsFromMap = (
  map: mapboxgl.Map,
  legendLayers: string[]
): MapLegend[] => {
  if (!map) {
    return []
  }

  const style = map.getStyle()
  const layersIds: string[] = legendLayers
  const layers: any = style.layers.filter(({ id }) => layersIds.includes(id))
  return layers.map((layer: any) => ({
    label: layer.id,
    color: layer.paint['fill-color'],
    show: true,
  }))
}

const shouldShowLegend = (type: string, lotsCount: number) => {
  if (
    (type === LotTypes.MODEL || type === LotTypes.RESERVED) &&
    lotsCount <= 0
  ) {
    return false
  }

  return true
}

const getThemeLayers = (
  project: any,
  selectedLayers: Array<any> = [],
  lotStatus: any = {}
): Array<any> => {
  if (!project || !project.theme) {
    return []
  }

  if (selectedLayers.length <= 0) {
    return []
  }

  return project.theme.layers
    .filter((layer: any) => selectedLayers.includes(layer.key))
    .map((layer: any) => ({
      ...layer,
      show: shouldShowLegend(
        layer.key,
        lotStatus[layer.key] ? lotStatus[layer.key].length : 0
      ),
      status: layer.key,
    }))
}

export {
  retrieveLegendsFromMap,
  retrieveLegendsMap,
  shouldShowLegend,
  getThemeLayers,
}
